(() => {
  const moneyFormatter = (currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "de", {
        style: "currency",
        currency: currency || "CNY"
      });
    } catch (error) {
      return null;
    }
  };

  const formatMoney = (cents, currency) => {
    const formatter = moneyFormatter(currency);
    if (formatter) return formatter.format((cents || 0) / 100);
    return `${((cents || 0) / 100).toFixed(2)} ${currency || ""}`.trim();
  };

  const escapeHtml = (value) => String(value || "").replace(/[&<>"']/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
  }[character]));

  const formatMeasurementHtml = (value) => escapeHtml(value)
    .replace(/m2/gi, "m<sup>2</sup>")
    .replace(/m²/gi, "m<sup>2</sup>");

  const escapeRegExp = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const updateProductSourceIncludedSku = (variant, variants) => {
    const currentSku = String(variant.sku || "").trim();
    const knownSkus = Array.from(new Set(variants
      .map((item) => String(item.sku || "").trim())
      .filter(Boolean)))
      .sort((left, right) => right.length - left.length);

    document.querySelectorAll(".product-kits-source, .product-source").forEach((source) => {
      source.querySelectorAll(".quadro-kit-tabs").forEach((tabs) => {
        const tabItems = Array.from(tabs.children).filter((item) => item.classList.contains("quadro-kit-tab"));
        const includedTab = tabItems[1];
        const panelId = includedTab && includedTab.getAttribute("aria-controls");
        if (!panelId) return;

        const panel = Array.from(source.querySelectorAll(".quadro-kit-tab-content"))
          .find((item) => item.id === panelId);
        if (!panel) return;

        const existingMarker = panel.querySelector("[data-product-source-variant-sku]");
        if (existingMarker) {
          existingMarker.textContent = currentSku;
          const existingWrap = existingMarker.closest("[data-product-source-variant-sku-wrap]");
          if (existingWrap) existingWrap.hidden = !currentSku;
          return;
        }

        const listItems = Array.from(panel.querySelectorAll("li"));
        if (listItems.length === 0) return;

        let targetItem = null;
        let skuMatch = null;

        listItems.some((item) => {
          const text = item.textContent || "";
          return knownSkus.some((knownSku) => {
            const pattern = new RegExp(`[（(]\\s*${escapeRegExp(knownSku)}\\s*[)）]`);
            const match = text.match(pattern);
            if (!match) return false;
            targetItem = item;
            skuMatch = match;
            return true;
          });
        });

        if (!targetItem && source.classList.contains("product-kits-source")) {
          targetItem = listItems[0];
        }
        if (!targetItem) return;

        const originalText = (targetItem.textContent || "").trim();
        const baseText = skuMatch
          ? `${originalText.slice(0, skuMatch.index)}${originalText.slice(skuMatch.index + skuMatch[0].length)}`
            .replace(/\s{2,}/g, " ")
            .trim()
          : originalText;
        const useWideParentheses = Boolean(skuMatch && skuMatch[0].trim().startsWith("（"));

        const skuWrap = document.createElement("span");
        skuWrap.dataset.productSourceVariantSkuWrap = "";
        skuWrap.hidden = !currentSku;
        skuWrap.append(document.createTextNode(useWideParentheses ? "（" : "("));

        const skuValue = document.createElement("span");
        skuValue.dataset.productSourceVariantSku = "";
        skuValue.textContent = currentSku;
        skuWrap.append(skuValue, document.createTextNode(useWideParentheses ? "）" : ")"));

        targetItem.textContent = baseText;
        targetItem.append(document.createTextNode(" "), skuWrap);
      });
    });
  };

  const setupProductVariants = () => {
    document.querySelectorAll("[data-product-root]").forEach((root) => {
      const select = root.querySelector("[data-variant-select]");
      const data = root.querySelector("[data-product-variants]");
      const image = root.querySelector("[data-product-image]");
      const lightboxTrigger = root.querySelector("[data-product-root-gallery-trigger]");
      const gallerySlides = Array.from(root.querySelectorAll("[data-product-gallery-slide]"));
      const galleryThumbs = Array.from(root.querySelectorAll("[data-product-gallery-thumb]"));
      const sku = root.querySelector("[data-variant-sku]");
      const skuRow = root.querySelector("[data-variant-sku-row]");
      const includedSku = root.querySelector("[data-variant-included-sku]");
      const includedSkuWrap = root.querySelector("[data-variant-included-sku-wrap]");
      const barcode = root.querySelector("[data-variant-barcode]");
      const barcodeRow = root.querySelector("[data-variant-barcode-row]");
      const variantTitle = root.querySelector("[data-variant-title]");
      const variantTitleRow = root.querySelector("[data-variant-title-row]");
      const dimension = root.querySelector("[data-variant-dimension]");
      const dimensionRow = root.querySelector("[data-variant-dimension-row]");
      const platform = root.querySelector("[data-variant-platform]");
      const platformRow = root.querySelector("[data-variant-platform-row]");
      const price = root.querySelector("[data-product-price]");
      const button = root.querySelector("[data-add-to-cart-button]");
      const swatches = Array.from(root.querySelectorAll("[data-variant-swatch]"));
      const links = Array.from(root.querySelectorAll("[data-product-link]"));

      if (!select || !data || !button) return;

      let variants = [];
      try {
        variants = JSON.parse(data.textContent);
      } catch (error) {
        variants = [];
      }

      if (root.dataset.randomVariant === "true" && variants.length > 1) {
        const availableVariants = variants.filter((variant) => variant.available);
        const variantPool = availableVariants.length > 0 ? availableVariants : variants;
        const randomVariant = variantPool[Math.floor(Math.random() * variantPool.length)];
        if (randomVariant) select.value = String(randomVariant.id);
      }

      const setActiveGalleryImage = (imageId) => {
        if (!imageId || gallerySlides.length === 0) return false;
        const targetId = String(imageId);
        const activeSlide = gallerySlides.find((slide) => String(slide.dataset.productMediaImageId) === targetId);
        if (!activeSlide) return false;

        gallerySlides.forEach((slide) => {
          const isActive = slide === activeSlide;
          slide.classList.toggle("is-active", isActive);
          slide.hidden = !isActive;
        });

        galleryThumbs.forEach((thumb) => {
          const isActive = String(thumb.dataset.productMediaImageId) === targetId;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-current", isActive ? "true" : "false");
        });

        return true;
      };

      galleryThumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
          setActiveGalleryImage(thumb.dataset.productMediaImageId);
        });
      });

      const updateVariant = () => {
        const variant = variants.find((item) => String(item.id) === String(select.value));
        if (!variant) return;

        const galleryUpdated = variant.imageId && setActiveGalleryImage(variant.imageId);
        if (!galleryUpdated && image && variant.image) {
          image.src = variant.image;
          image.alt = variant.imageAlt || "";
        }

        if (lightboxTrigger && variant.imageFull) {
          lightboxTrigger.dataset.lightboxSrc = variant.imageFull;
          lightboxTrigger.dataset.lightboxThumb = variant.imageThumb || variant.imageFull;
          lightboxTrigger.dataset.lightboxAlt = variant.imageAlt || "";
        }

        if (sku) {
          sku.textContent = variant.sku || sku.dataset.empty;
          if (skuRow) skuRow.hidden = !variant.sku;
        }

        if (includedSku) {
          includedSku.textContent = variant.sku || "";
          if (includedSkuWrap) includedSkuWrap.hidden = !variant.sku;
        }

        updateProductSourceIncludedSku(variant, variants);

        if (barcode) {
          barcode.textContent = variant.barcode || barcode.dataset.empty;
          if (barcodeRow) barcodeRow.hidden = !variant.barcode;
        }

        if (variantTitle) {
          const title = variant.title === "Default Title" ? "" : variant.title;
          variantTitle.textContent = title;
          if (variantTitleRow) variantTitleRow.hidden = !title;
        }

        if (dimension) {
          dimension.innerHTML = formatMeasurementHtml(variant.dimension || "");
          if (dimensionRow) dimensionRow.hidden = !variant.dimension;
        }

        if (platform) {
          platform.innerHTML = formatMeasurementHtml(variant.platform || "");
          if (platformRow) platformRow.hidden = !variant.platform;
        }

        if (price) {
          price.textContent = variant.price;
        }

        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.addText : button.dataset.soldOutText;

        links.forEach((link) => {
          try {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set("variant", variant.id);
            link.href = `${url.pathname}${url.search}${url.hash}`;
          } catch (error) {
            return;
          }
        });

        swatches.forEach((swatch) => {
          const isActive = String(swatch.dataset.variantId) === String(variant.id);
          swatch.classList.toggle("is-active", isActive);
          swatch.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
      };

      select.addEventListener("change", updateVariant);
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", () => {
          select.value = swatch.dataset.variantId;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
      updateVariant();
    });
  };

  const setupProductTabs = () => {
    document.querySelectorAll("[data-product-tabs]").forEach((root) => {
      const buttons = Array.from(root.querySelectorAll("[data-product-tab]"));
      const panels = Array.from(root.querySelectorAll("[data-product-tab-panel]"));

      if (buttons.length === 0 || panels.length === 0) return;

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const target = button.dataset.productTab;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle("is-active", active);
            item.setAttribute("aria-selected", active ? "true" : "false");
          });
          panels.forEach((panel) => {
            panel.classList.toggle("is-active", panel.dataset.productTabPanel === target);
          });
        });
      });
    });
  };

  const setupProductLightbox = () => {
    const triggers = Array.from(document.querySelectorAll("[data-product-lightbox-trigger]"));
    if (triggers.length === 0) return;

    const entries = [];
    triggers.forEach((trigger) => {
      const src = trigger.dataset.lightboxSrc;
      if (!src) return;
      entries.push({
        trigger,
        group: trigger.dataset.lightboxGroup || "",
        src,
        alt: trigger.dataset.lightboxAlt || "",
        thumb: trigger.dataset.lightboxThumb || src
      });
    });

    if (entries.length === 0) return;

    const labels = {
      close: triggers[0].dataset.lightboxCloseLabel || "Close",
      previous: triggers[0].dataset.lightboxPreviousLabel || "Previous image",
      next: triggers[0].dataset.lightboxNextLabel || "Next image"
    };

    const dialog = document.createElement("dialog");
    dialog.className = "product-lightbox";
    dialog.innerHTML = `
      <div class="product-lightbox__frame">
        <button class="product-lightbox__close" type="button" data-product-lightbox-close aria-label="${escapeHtml(labels.close)}">
          <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="m6 6 12 12M18 6 6 18"/></svg>
        </button>
        <div class="product-lightbox__stage">
          <button class="product-lightbox__arrow product-lightbox__arrow--prev" type="button" data-product-lightbox-prev aria-label="${escapeHtml(labels.previous)}">
            <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"/></svg>
          </button>
          <img class="product-lightbox__image" alt="">
          <button class="product-lightbox__arrow product-lightbox__arrow--next" type="button" data-product-lightbox-next aria-label="${escapeHtml(labels.next)}">
            <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="m9 6 6 6-6 6"/></svg>
          </button>
        </div>
        <div class="product-lightbox__footer">
          <span class="product-lightbox__counter" data-product-lightbox-counter></span>
          <div class="product-lightbox__thumbs" data-product-lightbox-thumbs></div>
        </div>
      </div>
    `;
    document.body.appendChild(dialog);

    let activeIndex = 0;
    let items = [];
    const image = dialog.querySelector(".product-lightbox__image");
    const counter = dialog.querySelector("[data-product-lightbox-counter]");
    const prev = dialog.querySelector("[data-product-lightbox-prev]");
    const next = dialog.querySelector("[data-product-lightbox-next]");
    const thumbs = dialog.querySelector("[data-product-lightbox-thumbs]");

    const render = () => {
      const item = items[activeIndex];
      if (!item || !image) return;
      image.src = item.src;
      image.alt = item.alt;
      if (counter) counter.textContent = `${activeIndex + 1} / ${items.length}`;
      if (prev) prev.hidden = items.length < 2;
      if (next) next.hidden = items.length < 2;
      if (thumbs) {
        thumbs.querySelectorAll("[data-product-lightbox-thumb]").forEach((thumb, index) => {
          const isActive = index === activeIndex;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-current", isActive ? "true" : "false");
          if (isActive) thumb.scrollIntoView({ block: "nearest", inline: "center" });
        });
      }
    };

    const goTo = (index) => {
      activeIndex = (index + items.length) % items.length;
      render();
    };

    function openLightbox(index) {
      activeIndex = index;
      render();
      document.documentElement.classList.add("product-lightbox-is-open");
      if (dialog.showModal) {
        dialog.showModal();
      } else {
        dialog.setAttribute("open", "");
      }
    }

    const openForTrigger = (trigger) => {
      const group = trigger.dataset.lightboxGroup || "";
      const activeEntries = group
        ? entries.filter((entry) => entry.group === group)
        : entries.filter((entry) => entry.trigger === trigger);
      items = activeEntries.map((entry) => ({
        src: entry.trigger.dataset.lightboxSrc || entry.src,
        alt: entry.trigger.dataset.lightboxAlt || entry.alt,
        thumb: entry.trigger.dataset.lightboxThumb || entry.thumb
      })).filter((item) => item.src);
      if (thumbs) {
        thumbs.innerHTML = items
          .map((item, itemIndex) => `
            <button class="product-lightbox__thumb" type="button" data-product-lightbox-thumb="${itemIndex}" aria-label="${itemIndex + 1}">
              <img src="${escapeHtml(item.thumb)}" alt="${escapeHtml(item.alt)}">
            </button>
          `)
          .join("");
        thumbs.querySelectorAll("[data-product-lightbox-thumb]").forEach((thumb) => {
          thumb.addEventListener("click", () => goTo(Number(thumb.dataset.productLightboxThumb)));
        });
      }
      const index = activeEntries.findIndex((entry) => entry.trigger === trigger);
      openLightbox(index > -1 ? index : 0);
    };

    entries.forEach((entry) => {
      entry.trigger.addEventListener("click", () => openForTrigger(entry.trigger));
    });

    const closeLightbox = () => {
      document.documentElement.classList.remove("product-lightbox-is-open");
      if (dialog.open && dialog.close) {
        dialog.close();
      } else {
        dialog.removeAttribute("open");
      }
    };

    dialog.querySelector("[data-product-lightbox-close]").addEventListener("click", closeLightbox);
    if (prev) prev.addEventListener("click", () => goTo(activeIndex - 1));
    if (next) next.addEventListener("click", () => goTo(activeIndex + 1));

    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) closeLightbox();
    });

    dialog.addEventListener("close", () => {
      document.documentElement.classList.remove("product-lightbox-is-open");
    });

    document.addEventListener("keydown", (event) => {
      if (!dialog.open) return;
      if (event.key === "ArrowLeft") goTo(activeIndex - 1);
      if (event.key === "ArrowRight") goTo(activeIndex + 1);
    });
  };

  const setupMenuAccordions = () => {
    const closeSiblings = (current, selector) => {
      document.querySelectorAll(selector).forEach((details) => {
        if (details !== current) details.removeAttribute("open");
      });
    };

    document.querySelectorAll(".nav-dropdown").forEach((details) => {
      details.addEventListener("toggle", () => {
        if (details.open) closeSiblings(details, ".nav-dropdown");
      });
    });

    document.querySelectorAll(".mobile-menu__panel details").forEach((details) => {
      details.addEventListener("toggle", () => {
        if (details.open) closeSiblings(details, ".mobile-menu__panel details");
      });
    });

    document.querySelectorAll("[data-mobile-menu-close]").forEach((button) => {
      button.addEventListener("click", () => {
        const menu = button.closest(".mobile-menu");
        if (menu) menu.removeAttribute("open");
      });
    });
  };

  const setupProductSlider = () => {
    document.querySelectorAll("[data-product-slider]").forEach((slider) => {
      const track = slider.querySelector("[data-product-slider-track]");
      const slides = track ? Array.from(track.querySelectorAll("[data-product-slider-slide]")) : [];
      const prev = slider.querySelector("[data-product-slider-prev]");
      const next = slider.querySelector("[data-product-slider-next]");
      const dots = slider.querySelector("[data-product-slider-dots]");

      if (!track || slides.length === 0) return;

      let activeIndex = 0;
      let ticking = false;
      let isDragging = false;
      let didDrag = false;
      let startX = 0;
      let startScroll = 0;

      const closestIndex = () => {
        let closest = 0;
        let closestDistance = Infinity;
        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (distance < closestDistance) {
            closest = index;
            closestDistance = distance;
          }
        });
        return closest;
      };

      const update = () => {
        activeIndex = closestIndex();
        if (dots) {
          dots.querySelectorAll("[data-product-slider-dot]").forEach((dot, index) => {
            const isActive = index === activeIndex;
            dot.classList.toggle("is-active", isActive);
            dot.setAttribute("aria-current", isActive ? "true" : "false");
          });
        }
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      };

      const goTo = (index) => {
        let safeIndex = index;
        if (safeIndex < 0) safeIndex = slides.length - 1;
        if (safeIndex > slides.length - 1) safeIndex = 0;
        track.scrollTo({
          left: slides[safeIndex].offsetLeft - track.offsetLeft,
          behavior: "smooth"
        });
      };

      if (dots) {
        dots.innerHTML = slides
          .map((slide, index) => {
            const label = (dots.dataset.dotLabel || "").replace("[number]", String(index + 1));
            return `<button class="product-slider__dot" type="button" data-product-slider-dot aria-label="${label}"></button>`;
          })
          .join("");

        dots.querySelectorAll("[data-product-slider-dot]").forEach((dot, index) => {
          dot.addEventListener("click", () => goTo(index));
        });
      }

      if (prev) prev.addEventListener("click", () => goTo(activeIndex - 1));
      if (next) next.addEventListener("click", () => goTo(activeIndex + 1));

      track.addEventListener("scroll", requestUpdate, { passive: true });
      track.addEventListener("pointerdown", (event) => {
        if (event.button !== 0) return;
        isDragging = true;
        didDrag = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add("is-dragging");
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener("pointermove", (event) => {
        if (!isDragging) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 4) didDrag = true;
        track.scrollLeft = startScroll - delta;
        event.preventDefault();
      });

      const stopDragging = (event) => {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove("is-dragging");
        if (track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }
        goTo(closestIndex());
      };

      track.addEventListener("pointerup", stopDragging);
      track.addEventListener("pointercancel", stopDragging);
      track.addEventListener("click", (event) => {
        if (!didDrag) return;
        event.preventDefault();
        event.stopPropagation();
        didDrag = false;
      }, true);

      update();
    });
  };

  const setupHomepageSlideshow = () => {
    document.querySelectorAll(".slideshow[data-autorotate]").forEach((slider) => {
      if (slider.dataset.homepageSlideshowReady === "true") return;

      const slides = Array.from(slider.querySelectorAll(".slideshow__slide"));
      const wrapper = slider.closest(".slideshow-wrapper") || slider;
      const prev = wrapper.querySelector(".slideshow__arrow-left");
      const next = wrapper.querySelector(".slideshow__arrow-right");
      const pause = wrapper.querySelector(".slideshow__pause");
      const arrows = wrapper.querySelector(".slideshow__arrows");

      if (slides.length === 0) return;

      slider.dataset.homepageSlideshowReady = "true";

      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
      let timer = null;
      let isPaused = slider.dataset.autorotate !== "true";
      let isDragging = false;
      let startX = 0;

      const dots = document.createElement("ul");
      dots.className = "quadro-slideshow__dots";
      dots.setAttribute("role", "tablist");
      dots.innerHTML = slides
        .map((slide, index) => {
          const label = (slider.dataset.slideNavA11y || "Load slide [slide_number]").replace("[slide_number]", String(index + 1));
          return `<li role="presentation"><button type="button" data-slideshow-dot="${index}" aria-label="${label}"></button></li>`;
        })
        .join("");

      if (arrows && slides.length > 1 && !arrows.querySelector(".quadro-slideshow__dots")) {
        arrows.appendChild(dots);
      }

      const dotButtons = Array.from(wrapper.querySelectorAll("[data-slideshow-dot]"));
      const speed = Number(slider.dataset.speed) || 7000;

      const update = () => {
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.classList.toggle("is-active", active);
          slide.setAttribute("aria-hidden", active ? "false" : "true");
        });

        dotButtons.forEach((dot, index) => {
          const active = index === activeIndex;
          dot.classList.toggle("is-active", active);
          dot.setAttribute("aria-current", active ? "true" : "false");
        });

        slider.classList.add("is-ready");
      };

      const stopTimer = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const startTimer = () => {
        stopTimer();
        if (isPaused || slides.length < 2) return;
        timer = window.setInterval(() => goTo(activeIndex + 1), speed);
      };

      const goTo = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        update();
        startTimer();
      };

      dotButtons.forEach((dot, index) => {
        dot.addEventListener("click", () => goTo(index));
      });

      if (prev) prev.addEventListener("click", () => goTo(activeIndex - 1));
      if (next) next.addEventListener("click", () => goTo(activeIndex + 1));

      if (pause) {
        pause.addEventListener("click", () => {
          isPaused = !isPaused;
          pause.setAttribute("aria-pressed", isPaused ? "true" : "false");
          pause.classList.toggle("is-paused", isPaused);
          startTimer();
        });
      }

      slider.addEventListener("pointerdown", (event) => {
        if (event.button !== 0 || slides.length < 2) return;
        isDragging = true;
        startX = event.clientX;
        slider.classList.add("is-dragging");
        slider.setPointerCapture(event.pointerId);
      });

      slider.addEventListener("pointerup", (event) => {
        if (!isDragging) return;
        isDragging = false;
        slider.classList.remove("is-dragging");
        if (slider.hasPointerCapture(event.pointerId)) {
          slider.releasePointerCapture(event.pointerId);
        }

        const delta = event.clientX - startX;
        if (Math.abs(delta) > 40) {
          goTo(delta < 0 ? activeIndex + 1 : activeIndex - 1);
        }
      });

      slider.addEventListener("pointercancel", () => {
        isDragging = false;
        slider.classList.remove("is-dragging");
      });

      update();
      startTimer();
    });
  };

  const setupLazyBackgrounds = () => {
    const backgrounds = Array.from(document.querySelectorAll("[data-lazy-background]"));
    if (backgrounds.length === 0) return;

    const loadBackground = (element) => {
      const src = element.dataset.lazyBackground;
      if (!src) return;
      element.style.backgroundImage = `url("${src}")`;
      element.removeAttribute("data-lazy-background");
    };

    if (!("IntersectionObserver" in window)) {
      backgrounds.forEach(loadBackground);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadBackground(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: "600px 0px" });

    backgrounds.forEach((element) => observer.observe(element));
  };

  const setupSearchOverlay = () => {
    const overlay = document.querySelector("[data-search-overlay]");
    const openButtons = document.querySelectorAll("[data-search-open]");
    const closeButtons = overlay ? overlay.querySelectorAll("[data-search-close]") : [];
    const input = overlay ? overlay.querySelector("[data-search-input]") : null;

    if (!overlay || openButtons.length === 0) return;

    const openSearch = () => {
      overlay.hidden = false;
      document.documentElement.classList.add("search-is-open");
      openButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "true");
      });
      requestAnimationFrame(() => {
        overlay.classList.add("is-open");
        if (input) input.focus();
      });
    };

    const closeSearch = () => {
      overlay.classList.remove("is-open");
      document.documentElement.classList.remove("search-is-open");
      openButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });
      setTimeout(() => {
        overlay.hidden = true;
      }, 180);
    };

    openButtons.forEach((button) => {
      button.addEventListener("click", openSearch);
    });

    closeButtons.forEach((button) => {
      button.addEventListener("click", closeSearch);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !overlay.hidden) closeSearch();
    });
  };

  const drawer = document.querySelector("[data-cart-drawer]");
  const drawerItems = drawer ? drawer.querySelector("[data-cart-drawer-items]") : null;
  const drawerFooter = drawer ? drawer.querySelector("[data-cart-drawer-footer]") : null;

  const openDrawer = () => {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add("is-open"));
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    setTimeout(() => {
      drawer.hidden = true;
    }, 220);
  };

  const renderDrawerActions = (cart) => {
    if (!cart) {
      return `
        <div class="cart-drawer__actions cart-drawer__actions--single">
          <a class="button" href="${drawer.dataset.continueShoppingUrl || "/collections/classic-kits"}">${drawer.dataset.continueShopping}</a>
        </div>
      `;
    }

    const subtotal = cart
      ? `<p><strong>${drawer.dataset.subtotal}: ${formatMoney(cart.total_price, cart.currency)}</strong></p>`
      : "";

    return `
      ${subtotal}
      <div class="cart-drawer__actions">
        <a class="button button--secondary" href="${drawer.dataset.cartUrl}">${drawer.dataset.viewCart}</a>
        <a class="button" href="${drawer.dataset.checkoutUrl}">${drawer.dataset.checkout}</a>
      </div>
    `;
  };

  const updateCartCounters = (cart) => {
    if (!cart) return;
    document.querySelectorAll("[data-cart-count]").forEach((counter) => {
      counter.dataset.cartCount = String(cart.item_count || 0);
      counter.textContent = String(cart.item_count || 0);
    });
  };

  const renderDrawer = (cart) => {
    if (!drawer || !drawerItems || !drawerFooter) return;

    updateCartCounters(cart);

    if (!cart.items || cart.items.length === 0) {
      drawerItems.innerHTML = `<p class="muted">${drawer.dataset.empty}</p>`;
      drawerFooter.innerHTML = renderDrawerActions(null);
      return;
    }

    drawerItems.innerHTML = cart.items
      .map((item) => {
        const itemTitle = escapeHtml(item.product_title || item.title || "");
        const itemUrl = escapeHtml(item.url || "#");
        const lineKey = escapeHtml(item.key || "");
        const image = item.image
          ? `<img src="${escapeHtml(item.image)}" alt="${itemTitle}" loading="lazy">`
          : "";
        const variantTitle = item.variant_title && item.variant_title !== "Default Title"
          ? `<p class="cart-drawer__variant">${escapeHtml(item.variant_title)}</p>`
          : "";
        const sku = item.sku ? `<p class="cart-drawer__sku">${escapeHtml(item.sku)}</p>` : "";
        return `
          <article class="cart-drawer__item" data-cart-drawer-line>
            <a class="cart-drawer__image" href="${itemUrl}">${image}</a>
            <div class="cart-drawer__details">
              <h3><a href="${itemUrl}">${itemTitle}</a></h3>
              ${variantTitle}
              ${sku}
              <div class="cart-drawer__line-controls">
                <label class="visually-hidden" for="CartDrawerQuantity-${lineKey}">${drawer.dataset.quantity}</label>
                <input
                  id="CartDrawerQuantity-${lineKey}"
                  class="cart-drawer__quantity-input"
                  type="number"
                  min="0"
                  inputmode="numeric"
                  value="${item.quantity}"
                  data-cart-drawer-quantity
                  data-cart-line-key="${lineKey}"
                  aria-label="${drawer.dataset.quantity}: ${itemTitle}"
                >
                <button
                  class="cart-drawer__remove"
                  type="button"
                  data-cart-drawer-remove
                  data-cart-line-key="${lineKey}"
                  aria-label="${drawer.dataset.remove}: ${itemTitle}"
                >
                  <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
                    <path d="M9 3h6l1 2h4v2H4V5h4l1-2Zm-2 6h10l-.7 11H7.7L7 9Zm3 2v7h2v-7h-2Zm4 0v7h2v-7h-2Z"/>
                  </svg>
                </button>
              </div>
              <p class="cart-drawer__line-price">${formatMoney(item.final_line_price, cart.currency)}</p>
            </div>
          </article>
        `;
      })
      .join("");

    drawerFooter.innerHTML = renderDrawerActions(cart);
  };

  const setCartDrawerBusy = (busy) => {
    if (!drawer || !drawerItems) return;
    drawer.classList.toggle("is-updating", busy);
    drawerItems.querySelectorAll("input, button").forEach((control) => {
      control.disabled = busy;
    });
  };

  const changeCartItem = async (lineKey, quantity) => {
    if (!lineKey) return;
    setCartDrawerBusy(true);
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity
        })
      });

      if (!response.ok) throw new Error("Cart change failed");
      const cart = await response.json();
      renderDrawer(cart);
    } finally {
      setCartDrawerBusy(false);
    }
  };

  const refreshCartDrawer = async () => {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Cart request failed");
    const cart = await response.json();
    renderDrawer(cart);
    openDrawer();
  };

  const setupCartDrawer = () => {
    if (!drawer) return;

    drawer.querySelectorAll("[data-cart-drawer-close]").forEach((button) => {
      button.addEventListener("click", closeDrawer);
    });

    if (drawerItems) {
      drawerItems.addEventListener("change", (event) => {
        const input = event.target.closest("[data-cart-drawer-quantity]");
        if (!input) return;
        const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
        input.value = String(quantity);
        changeCartItem(input.dataset.cartLineKey, quantity).catch(refreshCartDrawer);
      });

      drawerItems.addEventListener("click", (event) => {
        const button = event.target.closest("[data-cart-drawer-remove]");
        if (!button) return;
        event.preventDefault();
        changeCartItem(button.dataset.cartLineKey, 0).catch(refreshCartDrawer);
      });
    }

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeDrawer();
    });

    document.querySelectorAll("[data-cart-add-form]").forEach((form) => {
      form.addEventListener("submit", async (event) => {
        if (!window.matchMedia("(min-width: 860px)").matches) return;
        event.preventDefault();

        const button = form.querySelector("[data-add-to-cart-button]");
        if (button && button.disabled) return;

        try {
          if (button) button.disabled = true;
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { Accept: "application/json" },
            body: new FormData(form)
          });

          if (!response.ok) throw new Error("Add to cart failed");
          await refreshCartDrawer();
        } catch (error) {
          form.submit();
        } finally {
          if (button) button.disabled = false;
        }
      });
    });
  };

  const setupMobileBackToTop = () => {
    const button = document.querySelector("[data-mobile-back-to-top]");
    if (!button) return;

    const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    let animationFramePending = false;

    const updateVisibility = () => {
      const scrollThreshold = Math.max(480, window.innerHeight * 0.75);
      const isVisible = window.scrollY > scrollThreshold;

      button.classList.toggle("is-visible", isVisible);
      button.tabIndex = isVisible ? 0 : -1;
      button.setAttribute("aria-hidden", isVisible ? "false" : "true");
      animationFramePending = false;
    };

    const requestVisibilityUpdate = () => {
      if (animationFramePending) return;
      animationFramePending = true;
      window.requestAnimationFrame(updateVisibility);
    };

    button.hidden = false;
    button.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: reducedMotionQuery.matches ? "auto" : "smooth"
      });
    });

    window.addEventListener("scroll", requestVisibilityUpdate, { passive: true });
    window.addEventListener("resize", requestVisibilityUpdate);
    updateVisibility();
  };

  setupMenuAccordions();
  setupSearchOverlay();
  setupProductVariants();
  setupProductTabs();
  setupProductLightbox();
  setupProductSlider();
  setupHomepageSlideshow();
  setupLazyBackgrounds();
  setupCartDrawer();
  setupMobileBackToTop();
})();
;(() => {
  let pendingUrl = null;
  let activePointerId = null;
  let startX = 0;
  let startY = 0;

  const resetPendingLink = () => {
    pendingUrl = null;
    activePointerId = null;
    startX = 0;
    startY = 0;
  };

  const getTargetUrl = (clickedElement) => {
    if (clickedElement.matches("a[href]")) {
      return clickedElement.href;
    }

    /*
     * Vollflächige Slides haben keinen Button-Link im DOM. Ihre URL steht
     * direkt im inline onclick des .link_slide-Overlays.
     */
    const inlineHandler = clickedElement.getAttribute("onclick") || "";
    const inlineUrl = inlineHandler.match(
      /(?:window\.)?location(?:\.href)?\s*=\s*(['"])(.*?)\1/
    );

    if (inlineUrl && inlineUrl[2]) {
      try {
        return new URL(inlineUrl[2], window.location.href).href;
      } catch (error) {
        return null;
      }
    }

    const slide = clickedElement.closest(".slideshow__slide");
    const buttonLink = slide && slide.querySelector("a.slideshow__btn[href]");
    return buttonLink ? buttonLink.href : null;
  };

  document.addEventListener(
    "pointerdown",
    (event) => {
      if (event.button !== 0) return;

      const clickedElement = event.target.closest(
        ".link_slide, a.slideshow__btn"
      );

      if (!clickedElement) {
        resetPendingLink();
        return;
      }

      const targetUrl = getTargetUrl(clickedElement);

      if (!targetUrl) {
        resetPendingLink();
        return;
      }

      pendingUrl = targetUrl;
      activePointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
    },
    true
  );

  document.addEventListener(
    "pointerup",
    (event) => {
      if (
        activePointerId !== event.pointerId ||
        !pendingUrl
      ) {
        return;
      }

      const targetUrl = pendingUrl;
      const distanceX = Math.abs(event.clientX - startX);
      const distanceY = Math.abs(event.clientY - startY);

      resetPendingLink();

      /*
       * Bei mehr als 10 px Bewegung bleibt es ein Drag.
       */
      if (distanceX > 10 || distanceY > 10) return;

      event.preventDefault();
      window.location.assign(targetUrl);
    },
    true
  );

  document.addEventListener(
    "pointercancel",
    (event) => {
      if (activePointerId === event.pointerId) {
        resetPendingLink();
      }
    },
    true
  );
})();
